import React from "react";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ExcelDownload = ({ data }) => {
    return (
        <ExcelFile
            filename="Exchange_Report"
            element={<button style={{backgroundColor:"green", color:"white"}} className="ant-btn ant-btn-default">Download Excel</button>}
        >
            <ExcelSheet data={data} name="Exchange Report">
                <ExcelColumn label="SL." value={(col, index) => index + 1} />
                <ExcelColumn label="Invoice Number" value="invoice_number" />
                <ExcelColumn label="Status" value="status" />
                <ExcelColumn
                    label="Location"
                    value={(col) => (col.location ? col.location.name : "N/A")}
                />
                <ExcelColumn label="Bill" value="bill" />
                <ExcelColumn label="Discount" value="discount" />
                <ExcelColumn label="Payment" value="payment" />
                <ExcelColumn label="Issued Date" value="issue_date" />
                <ExcelColumn
                    label="Updated Date"
                    value={(col) =>
                        col.item_copy
                            ? col.item_copy
                                  .filter((item) => item.updated_at)
                                  .map((item) => item.updated_at)
                                  .join(", ")
                            : ""
                    }
                />
                <ExcelColumn
                    label="Sold Items"
                    value={(col) =>
                        col.item ? col.item.map((item) => item.Details).join(", ") : ""
                    }
                />
                <ExcelColumn
                    label="Exchanged Items"
                    value={(col) =>
                        col.item_copy
                            ? col.item_copy
                                  .filter((item) => item.is_exchanged)
                                  .map((item) => item.Details)
                                  .join(", ")
                            : ""
                    }
                />
                <ExcelColumn
                    label="Invoice Items"
                    value={(col) =>
                        col.item_copy ? col.item_copy.map((item) => item.Details).join(", ") : ""
                    }
                />
            </ExcelSheet>
        </ExcelFile>
    );
};

export default ExcelDownload;
